export default __webpack_public_path__ + "static/media/arrow.7a43e9f3.svg";